import React from "react";
import HeroCTR from "../containers/home/HeroCTR";
import InfoCTR from "../containers/home/InfoCTR";
import FindAdventureCTR from "../containers/home/FindAdventureCTR";
import TopTourCTR from "../containers/home/TopTourCTR";
import TopThreeCTR from "../containers/home/TopThreeCTR";
import ReviewCTR from "../containers/home/ReviewCTR";
import AllPackagesCTR from "../containers/home/AllPackagesCTR";

const Home = () => {
  return (
    <div>
      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <HeroCTR />
      </div>

      <InfoCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <FindAdventureCTR mt="mt-12" />
      </div>

      <TopTourCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <TopThreeCTR />
      </div>

      <ReviewCTR />

      <div className="-mx-6 sm:-mx-10 md:-mx-14 lg:-mx-20">
        <AllPackagesCTR />
      </div>
    </div>
  );
};

export default Home;